import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// BugZero page heading — the styleguide identity header (matches the ServiceNow
// / vendor configuration chrome): a bordered card with an icon tile, optional
// kicker, title and subtitle. Keeps the original API (title / subtitle / icon /
// className / loading) so every page that already uses <Heading> picks up the
// new style with no per-page changes. `kicker` is optional.
const Heading = ({ title, subtitle, className, icon, transform, loading, kicker, badge }) => (
  <div
    className={`bz-card ${className || ''}`}
    style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '16px 20px', marginBottom: 20 }}
  >
    {icon && (
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 10,
          background: 'var(--bg-tan)',
          color: 'var(--bz-blue-2)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          flexShrink: 0
        }}
      >
        <FontAwesomeIcon icon={icon} transform={transform} />
      </div>
    )}
    <div style={{ minWidth: 0 }}>
      {kicker && (
        <div className="bz-kicker" style={{ color: 'var(--prevent)' }}>
          {kicker}
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: kicker ? 2 : 0 }}>
        <h1 className="bz-h2" data-testid="heading" style={{ margin: 0 }}>
          {loading ? (
            <span
              className="loading-skeleton"
              style={{ display: 'inline-block', width: 220, height: '1em', borderRadius: 4 }}
            />
          ) : (
            title
          )}
        </h1>
        {!loading && badge}
      </div>
      {!loading && subtitle && (
        <div className="bz-muted" style={{ fontSize: 'var(--fs-sm)', marginTop: 4 }}>
          {subtitle}
        </div>
      )}
    </div>
  </div>
);

Heading.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  transform: PropTypes.string,
  loading: PropTypes.bool,
  kicker: PropTypes.string,
  badge: PropTypes.node
};

export default Heading;
